// extracted by mini-css-extract-plugin
module.exports = {"profileHeader":"styles_profileHeader__MQHrq","link":"styles_link__269Gf","active":"styles_active__3iIDV","right":"styles_right__3ka0Z"};